module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/05_9781455619825_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_9781455619825_Chapter_01"
    }
  }, [_vm._v("1. November 22, 1963: The Basic Facts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02"
    }
  }, [_vm._v("2. The Autopsy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/08_9781455619825_Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Non-Investigation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/09_9781455619825_Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A Fork in the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/10_9781455619825_Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Cuba—Rosetta Stone to the Assassination")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_9781455619825_Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Who Was Lee Harvey Oswald?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_9781455619825_Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Jack Ruby: Screwball or Mob Pawn?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_9781455619825_Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Case Against Oswald")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Enigma of Dealey Plaza")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_9781455619825_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Cover-Up—Villains & Heroes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_9781455619825_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Keeping the Lid On")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_9781455619825_Epilog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_9781455619825_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_9781455619825_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6023656a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/03_9781455619825_Contents.vue
// module id = 63
// module chunks = 0